export function initEnquiryModal(root) {
    const modal = root.querySelector('#chalet-enquiry-modal');
    let trigger;
    function close() {
        modal.hidden = true;
        modal.classList.remove('in');
        document.body.classList.remove('chalet-modal-open');
        trigger?.focus();
    }
    function open(source, arrival) {
        trigger = source;
        if (arrival) {
            const input = modal.querySelector('[name="arrival_date"]');
            input.value = arrival;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        }
        modal.hidden = false;
        modal.classList.add('in');
        document.body.classList.add('chalet-modal-open');
        modal.querySelector('input:not([type="hidden"])').focus();
    }
    document.addEventListener('chalet:enquire', event => open(event.detail.trigger));
    modal.querySelector('[data-chalet-close]').addEventListener('click', close);
    modal.addEventListener('click', event => { if (event.target === modal) close(); });
    modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key !== 'Tab') return;
        const elements = [...modal.querySelectorAll('button, input:not([type="hidden"]), select, textarea, a[href]')].filter(element => !element.disabled);
        const first = elements[0], last = elements[elements.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    root.querySelectorAll('[data-chalet-enquire]').forEach(button => button.addEventListener('click', () => open(button)));
    return {open, close};
}
